<script lang="ts">
    
    import type { Form } from "../Model/Form";
    import type { FormInstance } from "../Model/FormInstance";
    import { formsService } from "../Services";
    import Date from "./Date.svelte";
    import DownloadInstance from "./DownloadInstance.svelte";
    import FormListItem from "./FormListItem.svelte";

    type ListItem = {
        form: Form;
        instance: FormInstance;
    };

    export let instances: FormInstance[];

    let listItems: ListItem[] = [];

    $: setupComponent(instances);

    async function setupComponent(instances: FormInstance[]): Promise<void> {
        const forms = await Promise.all(instances.map(({ formId }) => formsService.getForm(formId)));
        listItems = instances.map((instance, index) => ({
            instance,
            form: forms[index]
        }));
    }

</script>

{#each listItems as { form, instance }}
    <FormListItem {form} />
    <div class="d-flex justify-content-between pb-2">
        <Date date={instance.dateCompleted} />
        <DownloadInstance id={instance.id} />
    </div>
{/each}
